<div class="wrapper-popup">
    <div
        [@overlay]
        class="overlay"
        (click)="dialogRef.close()"
        (swipedown)="dialogRef.close()"
    >
    </div>
    <div
        class="dialog"
        [@slidePopup]
    >
        <div class="wrapper-content">
            <ng-template navaarInsertion></ng-template>
        </div>
    </div>
</div>
